import strings from 'localization/strings';
import { handleResponse } from 'actions/actionHelpers';
import { fetchIloqRealEstates } from 'actions/iloq';

const lockTypes = {
    telkey: {
        format: lockConfiguration => lockConfiguration.data,
        useLockCodePage: true
    },
    parakey: {
        format: lockConfiguration => lockConfiguration.data,
        formatStorageSiteLockConfiguration: (lockConfiguration, dispatch, onCompleted) => {
            onCompleted(lockConfiguration.domainId);
        },
        useLockCodePage: false,
        isSynchronizable: true
    },
    iloq: {
        format: lockConfiguration => lockConfiguration.data,
        formatStorageSiteLockConfiguration: (lockConfiguration, dispatch, onCompleted) => {
            dispatch(fetchIloqRealEstates())
                .then(handleResponse(
                    response => {
                        const realEstate = response.payload.find(o => o.id === lockConfiguration.realEstateId);
                        onCompleted(realEstate?.name);
                    }
                ));
        },
        useLockCodePage: false,
        isSynchronizable: true
    },
    plaintext: {
        format: lockConfiguration => lockConfiguration.data,
        useLockCodePage: true
    }
};

Object.keys(lockTypes).forEach(key => {
    lockTypes[key].key = key;
});

strings.addLoadCallback(() => {
    Object.values(lockTypes).forEach(o => {
        o.title = strings.lockTypes[o.key].title;
        o.dataLabel = strings.lockTypes[o.key].dataLabel;
        o.takeoverInformation = strings.lockTypes[o.key].takeoverInformation;
    });
});

export default lockTypes;
